import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { toast } from 'react-toastify'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import { InputLabel, Typography } from '@material-ui/core'

import {
  Button,
  Modal,
  TextInput,
  PermissionSelect,
} from 'ui/components'

import {
  postCreateUser,
} from 'services/apiMotorBgcAdmin'

import messages from 'utils/messages'
import { isPermissionAdminOrGreater } from 'utils/validators'
import { USER_PERMISSION } from 'utils/constants/user'

import styles from './styles'

const validationSchema = Yup.object({
  email: Yup.string().required(messages.required),
  permission: Yup.string().required(messages.required),
})

const initialValues = {
  email: '',
  permission: USER_PERMISSION.COMMON,
}

export default ({ orgSelected, onCreate = null }) => {
  const classes = styles()

  const userId = useSelector((state) => state.auth.sub)
  const apiKey = useSelector((state) => state.auth.api_key)
  const accessToken = useSelector(state => state.auth.access_token)
  const userPermission = useSelector((state) => state.user.permission)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  if (!isPermissionAdminOrGreater(userPermission)) return null

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleCancel = () => {
    setModalOpen(false)
  }

  const handleUserCreate = async (values) => {
    setLoading(true)

    try {
      await postCreateUser(
        apiKey,
        userId,
        values.email,
        values.permission,
        orgSelected.org_id,
        accessToken,
      )
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao criar usuário'
      toast.error(messageError)
      setLoading(false)
      return
    }

    setLoading(false)
    setModalOpen(false)
    toast.success('Usuário criado com sucesso! Um email foi enviado para ele')

    if (_.isFunction(onCreate)) onCreate()
  }

  const renderEmailInput = () => {
    return (
      <div>
        <InputLabel>Email</InputLabel>
        <Field
          name="email"
          type="email"
          component={TextInput}
        />
      </div>
    )
  }

  const renderForm = () => {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleUserCreate}
      >
        {(form) => {
          return (
            <form>
              <div className={classes.fieldsContainer}>
                {renderEmailInput()}

                <PermissionSelect
                  value={form.values.permission}
                  orgName={orgSelected.name}
                  onChange={form.handleChange}
                  hasError={form.touched.permission && Boolean(form.errors.permission)}
                />
              </div>

              <div className={classes.buttonsContainer}>
                <Button onClick={handleCancel} variant="text">
                  Cancelar
                </Button>
                <Button onClick={form.handleSubmit} disabled={loading}>
                  Criar Usuário
                </Button>
              </div>
            </form>
          )
        }}
      </Formik>
    )
  }

  const renderOrgName = () => {
    const orgName = orgSelected.name
    if (_.isEmpty(orgName)) return null

    return (
      <div className={classes.orgNameContainer}>
        <Typography>
          Organização:
          {' '}
          <strong>{orgName}</strong>
        </Typography>
      </div>
    )
  }

  return (
    <div>
      <Button onClick={handleToggleModal}>
        Criar Usuário
      </Button>

      <Modal
        open={modalOpen}
        onClose={handleToggleModal}
        title="Criar Usuário"
      >
        {renderOrgName()}
        {renderForm()}
      </Modal>
    </div>
  )
}
